import type { SearchEntry } from './types';
import { panelDetails } from './panel-details';

type Item = [
  id: string,
  name: string,
  description: string,
  keywords: string,
  path: string,
  permission?: 'owner' | 'operate',
];
const items: Item[] = [
  ['dashboard', 'ダッシュボード', 'サーバーとノードの状態', 'dashboard ホーム 一覧 CPU メモリ TPS MSPT', '/'],
  [
    'create-server',
    'サーバーを作成',
    '新しいサーバーの名前・ソフト・配置・リソース',
    '新規 追加 create modpack インポート テンプレート',
    '/servers/new',
    'operate',
  ],
  ['settings', 'Panel の設定', 'アカウント・連携・表示', 'パネル settings', '/settings'],
  [
    'appearance',
    '表示・外観',
    '背景・テーマ・スタイル・文字の大きさ',
    'appearance theme フォント 色 ダーク ライト アニメーション',
    '/settings',
  ],
  [
    'about',
    'このパネルについて',
    'Panel の版・更新状況・リリースノート',
    'about version バージョン 履歴 アップデート',
    '/settings',
  ],
  [
    'auto-update',
    '新しいリリースを自動で入れる',
    'Panel の自動更新',
    '自動更新 auto deploy update ロールバック',
    '/settings',
    'owner',
  ],
  [
    'agent-update',
    'agent の更新',
    'サーバー内の agent の版と更新',
    'エージェント version update 自動更新',
    '/settings',
    'operate',
  ],
  [
    'launcher-download',
    'ランチャーの配布・ダウンロード',
    'Shouchan Launcher の入手と版',
    'launcher インストーラー Windows Mac Linux',
    '/settings',
  ],
  [
    'launcher-sync',
    'ランチャーを今すぐ取り込む',
    '最新のランチャーを配布',
    'launcher sync 更新 同期',
    '/settings',
    'owner',
  ],
  [
    'homepage',
    'ホームページ',
    'トップページの案内・Discord 招待',
    'homepage web サイト 公開 ホーム お知らせ',
    '/settings',
    'owner',
  ],
  [
    'account',
    'パスワードと認証アプリ',
    'アカウントの認証情報を変更',
    '2段階認証 二段階認証 2FA TOTP ワンタイム リカバリーコード password セキュリティ',
    '/settings',
  ],
  [
    'sftp',
    'SSH 鍵と SFTP',
    'SFTP 名・公開鍵の追加と削除・接続ポート',
    'sftp ssh OpenSSH ed25519 ECDSA RSA ファイル転送 鍵 指紋',
    '/settings',
  ],
  [
    'network-ip-bans',
    'IP BAN（全サーバー共通）',
    'IP・範囲を入口で落とす BAN の追加と解除',
    'ban ip アイピー 荒らし ブロック 締め出し nftables edge 全サーバー',
    '/settings',
  ],
  [
    'shared-database',
    '共有データベース',
    'サーバーをまたいでデータをそろえる MariaDB・Redis の VM',
    'database db mariadb mysql redis 経済 お金 同期 tne the new economy 共有 データベース',
    '/settings',
  ],
  [
    'mcp-policy',
    'AI からの変更・MCP の許可',
    'AI の操作で承認が必要な範囲',
    'MCP Claude 権限 policy 段階',
    '/settings',
    'owner',
  ],
  [
    'tokens',
    'AI 用アクセストークン（MCP）',
    '接続 URL・トークンの作成と失効',
    'MCP Claude Code token API キー コネクタ',
    '/settings',
  ],
  ['oauth', '接続を許可した AI アプリ', 'OAuth の許可と取り消し', 'OAuth MCP Claude コネクタ 接続 権限', '/settings'],
  ['discord', 'Discord 連携', 'Discord アカウントの連携と解除', 'discord ディスコード', '/settings'],
  [
    'users',
    '利用者・招待',
    '利用者の追加・権限・招待・認証情報の再設定',
    'user ユーザー invite 管理者 オーナー パスワード リセット',
    '/users',
    'owner',
  ],
  [
    'templates',
    'サーバーテンプレート',
    'ソフト・ゲーム設定・メモリ・Mod・配置のひな形',
    'template テンプレート JVM CPU ディスク ヒープ ノード 重さ プロパティ',
    '/templates?tab=server',
  ],
  [
    'client-templates',
    'クライアント Mod テンプレート',
    'クライアント Mod の作成・編集・割り当て・複製',
    'template client modpack Fabric ランチャー 必須 任意 版',
    '/templates?tab=client',
  ],
  [
    'template-tests',
    'クライアント Mod のテストとエラー',
    'テンプレートを開いて起動テストを確認',
    '検証 再テスト エラー ログ チェック 修復',
    '/templates?tab=client',
  ],
  [
    'routing',
    '接続先',
    'ホスト名・ルーティング・edge への反映',
    'routing DNS domain ドメイン IP アドレス ネットワーク Caddy Velocity',
    '/routing',
  ],
  ['jobs', 'ジョブ', '処理の進捗・結果・エラー', 'job タスク 履歴 実行中 失敗 ログ', '/jobs'],
  ['audit', '監査ログ', '誰が何を変更したか確認', 'audit 履歴 操作 記録', '/audit'],
  ['requests', '依頼・承認', '承認待ちの変更と履歴', 'request リクエスト 却下 申請 承認', '/requests'],
  [
    'velocity-overview',
    'Velocity の状態',
    '入口の状態・プレイヤー・再起動',
    'velocity proxy プロキシ hub edge',
    '/velocity?tab=overview',
  ],
  [
    'velocity-plugins',
    'Velocity のプラグイン',
    '入口のプラグインの追加・削除',
    'velocity plugin mod jar Modrinth',
    '/velocity?tab=plugins',
  ],
  [
    'velocity-bedrock',
    'Velocity の統合版',
    'Geyser・Floodgate の有効化と UDP ポート',
    'velocity bedrock 統合版 スマホ Switch 19132',
    '/velocity?tab=bedrock',
  ],
  [
    'velocity-files',
    'Velocity のファイル',
    '入口の設定ファイルを編集',
    'velocity file config toml アップロード ダウンロード',
    '/velocity?tab=files',
  ],
  [
    'velocity-version',
    'Velocity のバージョン',
    '入口のソフトの版を変更',
    'velocity version update 更新 ビルド',
    '/velocity?tab=version',
  ],
  [
    'velocity-logs',
    'Velocity のログ',
    '入口のログを確認',
    'velocity log console コンソール エラー',
    '/velocity?tab=logs',
  ],
];

export const panelIndex: SearchEntry[] = [
  ...items.map(([id, name, description, keywords, path, permission]) => ({
    id,
    name,
    description,
    keywords,
    path,
    permission,
    focus:
      (
        {
          appearance: 'appearance-mode',
          'template-tests': 'client-templates',
          'launcher-sync': 'launcher-download',
        } as Record<string, string>
      )[id] ?? id,
  })),
  ...panelDetails,
];
